export enum NewElectricityAgreementState {
    ACCEPT_TERMS,
    DATA_AND_METERING_POINTS,
    CHOOSE_PACKAGE,
    CONFIRM,
    COMPLETED
}

export interface ElectricityAgreementForm {
    customerName?: string;
    registryNumber?: string;
    vatRegistryNumber?: string;
    bankAccountNumber?: string;
    phone?: string;
    email?: string;
    address?: string; 
    city?: string;
    zip?: string;
    county?: string;
    startDate?: Date;
    validated: boolean;
    sellCheck: boolean;
    consolidatedInvoice: boolean;
    eInvoice: boolean;
    electricityInvoiceRecipientEmail?: string;
    electricityInvoiceRecipientEmailEnabled: boolean;
}

export interface CreateElectricityAgreementRequest {
    contactPersonId: number;
    email: string;
    phone: string;
    address: string;
    city?: string;
    zip?: string;
    county?: string;
    bankAccountNumber?: string;
    electricityInvoiceRecipientEmail?: string;
    meteringPoints: {
        id: number;
        productionCapacity: number;
    }[];
    consumptionPackageId: number;
    productionPackageId: number | null;
    startDate: string;
    consolidatedInvoice: boolean;
    eInvoice: boolean;
}

export interface ChangeElectricityAgreementPackageRequest {
    consumptionPackageId: number;
    productionPackageId: number | null;
    startDate: string;
    consolidatedInvoice: boolean;
    eInvoice: boolean;
    email: string;
    phone: string;
    address: string;
    city?: string;
    zip?: string;
    county?: string;
    bankAccountNumber? : string;
    electricityInvoiceRecipientEmail?: string;
}

export interface ElectricityResaleAgreementOfferRequest {
    contactPersonId: number;
    email: string;
    phone: string;
    address: string;
    bankAccountNumber? : string;
    electricityInvoiceRecipientEmail?: string;
    meteringPoints: {id: number, productionCapacity: number}[];
    consolidatedInvoice: boolean;
    eInvoice: boolean;
}

export interface AcceptElectricityAgreementOfferRequest {
    startDate: string, 
    endDate?: string;
    consolidatedInvoice: boolean, 
    eInvoice: boolean;
    email: string;
    phone: string;
    address: string;
    city?: string;
    zip?: string;
    county?: string;
    bankAccountNumber?: string;
    electricityInvoiceRecipientEmail?: string;
}

export interface ElectricityAgreementPdfPreviewRequest {
    contractNumber?: string;
    customerId: number;
    contactPersonId: string;
    meteringPointIds: number[];
    startDate: string;
    endDate?: string;
    contractPeriodId?: number;
    consumptionPackageId: number;
    productionPackageId?: number;
    consumptionMarginal: number;
    productionMarginal?: number;
    basePriceCentsKwh?: number;
    baseConsumptionProportion?: number;
    dayTariffCentsKwh?: number;
    nightTariffCentsKwh?: number;
    monthlyFeeEuros?: number;
    earlyTerminationFee?: number;
    estimatedConsumptionVolumeMwh?: number;
    estimatedConsumptionDayVolumeMwh?: number;
    estimatedConsumptionNightVolumeMwh?: number;
    email: string;
    phone: string;
    address: string;
}

export enum ElectricityPackageEarlyTerminationFeeType {
    FIXED_PER_LEFTOVER_MONTH = 'FIXED_PER_LEFTOVER_MONTH',
    PERCENTAGE_OF_VOLUME = 'PERCENTAGE_OF_VOLUME'
}

export interface ElectricityPackage {
    id: number;
    nameEt: string;
    nameEn: string;
    descriptionEt: string;
    descriptionEn: string;
    marketPricePackage: boolean;
    jointInvoicePackage: boolean;
    dynamicPackage: boolean;
    twoTariffPackage: boolean;
    baseFixationType?: ElectricityPackageBaseFixationType;
    baseConsumptionProportion?: number;
    termsAndConditions: string;
    basePriceCentsKwh?: number;
    dayTariffCentsKwh?: number;
    nightTariffCentsKwh?: number;
    basePriceTextEt?: string;
    basePriceTextEn?: string;
    basePriceDescriptionEt?: string;
    basePriceDescriptionEn?: string;
    fixedPrice: boolean;
    contractPeriod?: ContractPeriod;
    contractEndDate?: string;
    greenEnergy: boolean;
    marginal: number;
    averageMarketPrice?: number;
    monthlyFeeEuros?: number;
    earlyTerminationFeeType?: ElectricityPackageEarlyTerminationFeeType;
    earlyTerminationFee?: number;
    highlighted: boolean;
    orderNumber?: number;
    confirmationText?: string;
    agreementWithdrawalConditions?: string;
    type: ElectricityPackageType;
    meterType: ElectricityPackageMeterType;
    showToPrivateCustomer: boolean;
    showToBusinessCustomer: boolean;
}

export enum ElectricityPackageBaseFixationType {
    QUANTITY = 'QUANTITY',
    PERCENTAGE = 'PERCENTAGE'
}

export enum ElectricityPackageMeterType {
    QUARTER_HOUR = 'QUARTER_HOUR',
    HOUR = 'HOUR'
}

export const ELECTRICITY_PACKAGE_BASE_FIXATION_TYPE_MAP: Record<ElectricityPackageBaseFixationType, string> = {
    QUANTITY: 'Baastarbimine',
    PERCENTAGE: 'Protsent tarbimisest',
};

export interface ContractPeriod {
    id: number;
    name: string;
    type: ContractPeriodType
}

export enum ContractPeriodType {
    INDEFINITE = 'INDEFINITE',
    PERIOD = 'PERIOD',
    FIXED_DATE = 'FIXED_DATE',
    TEMPORARY = 'TEMPORARY'
}

export enum ElectricityPackageType {
    PRODUCTION = 'PRODUCTION',
    CONSUMPTION = 'CONSUMPTION'
}